import { render, staticRenderFns } from "./modalAdicionarNovoConvenio.vue?vue&type=template&id=0265f2f4"
import script from "./modalAdicionarNovoConvenio.vue?vue&type=script&lang=ts"
export * from "./modalAdicionarNovoConvenio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports